import React from 'react';
import { PropertyDetailsType } from '../../utility/types';
import { DisplayList, ListItem } from '../common/DisplayList';
import { formatFloat, formatUsd } from '../../utility/utility_functions';

type PropertyDetailsListProps = {
  propertyDetails: PropertyDetailsType;
};

const getDisplayItems = (propertyDetails: PropertyDetailsType): ListItem[] => [
  {
    name: 'Living Area',
    value: propertyDetails?.sqft
      ? `${formatFloat(propertyDetails.sqft)} sq ft`
      : 'N/A',
  },
  {
    name: 'Lot Size',
    value: propertyDetails?.lot_size_acres
      ? `${formatFloat(propertyDetails.lot_size_acres, 3)} acres`
      : 'N/A',
  },
  {
    name: 'Bedrooms',
    value: propertyDetails?.bedrooms
      ? propertyDetails.bedrooms.toString()
      : 'N/A',
  },
  {
    name: 'Bathrooms',
    value: propertyDetails?.bathrooms
      ? propertyDetails.bathrooms.toString()
      : 'N/A',
  },
  {
    name: 'Stories',
    value: propertyDetails?.stories
      ? propertyDetails.stories.toString()
      : 'N/A',
  },
  {
    name: 'Property Type',
    value: propertyDetails?.property_class ?? 'N/A',
  },
  {
    name: 'Year Build',
    value: propertyDetails?.year_built
      ? propertyDetails.year_built.toString()
      : 'N/A',
  },
  {
    name: 'Annual Taxes',
    value: propertyDetails?.total_tax_amount
      ? formatUsd(propertyDetails.total_tax_amount)
      : 'N/A',
  },
  {
    name: 'Days on Market',
    value: propertyDetails?.cumulative_days_on_market
      ? `${propertyDetails.cumulative_days_on_market.toString()} days`
      : 'N/A',
  },
  {
    name: 'Subdivision',
    value: propertyDetails?.subdivision ?? 'N/A',
  },
  {
    name: 'Garage',
    value: propertyDetails?.garage_spaces
      ? `${propertyDetails.garage_spaces.toString()} CAR`
      : 'N/A',
  },
];

export const PropertyDetailsList = ({
  propertyDetails,
}: PropertyDetailsListProps) => {
  const items = getDisplayItems(propertyDetails);
  return <DisplayList title="Property Details" items={items} />;
};
